import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { StudiesList } from "@/pages/Studies/StudiesList";

export const StudiesRoutes: React.FC = () => {
    return (
        <Routes>
            <Route path="/" element={<Navigate to="/studies/all" replace />} />
            <Route path="/:tab" element={<StudiesList />} />
        </Routes>
    );
};

export { StudiesList };
